var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasswithBowlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0851 13.665H4.00565L8.34447 60H28.7469L29.4563 52.4237L29.4598 52.3856L29.9208 47.4639L29.9243 47.4258V47.4239L33.0851 13.665ZM8.69436 1.87482L9.62389 11.7898H11.6497L11.6254 11.5271L10.6259 0.856934C10.5812 0.36914 10.1385 -0.00046964 9.62028 4.47906e-07H1.01015C0.45233 4.47906e-07 0 0.419994 0 0.93744C0 1.45537 0.452343 1.87488 1.01015 1.87488L8.69436 1.87482ZM59.886 53.4254H31.3881L30.7719 59.9993H56.1152C57.3333 59.9993 58.4312 59.6104 59.2192 58.9851C59.9641 58.3942 60.4266 57.5886 60.4266 56.7119V53.4254L59.886 53.4254ZM59.886 48.4651H31.8528L31.5637 51.5501H59.8864C60.4995 51.5501 61.0487 51.358 61.4381 51.0491C61.785 50.7737 62 50.4045 62 50.0076V50.0072C62 49.6107 61.7845 49.2416 61.4381 48.9661C61.2064 48.783 60.9194 48.6403 60.5953 48.5551L60.5456 48.5424C60.4437 48.5169 60.3443 48.4986 60.0953 48.4755L59.9422 48.4661L59.886 48.4651ZM42.7316 34.0635C40.8493 34.0635 39.0435 34.2999 37.3604 34.7373C35.7858 35.1455 34.3126 35.7303 32.9764 36.4592L32.0271 46.5903H59.8214C59.5308 43.2713 57.7062 40.2792 54.9045 38.0544C51.7989 35.5891 47.4962 34.0636 42.7313 34.0636",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasswithBowlIcon);
export default __webpack_public_path__ + "static/media/glasswithBowlIcon.d0342a3e5f1e393e57edc805812e6dc0.svg";
export { ForwardRef as ReactComponent };